export default {
      id: "link-2-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#link-2",
      toString: function () {
        return this.url;
      }
    }